<app-dialog [config]="data.config" (actionButtonClicked)="dialogRef.close()">
    <ng-container dialog-title>
        <i class="fa fa-money mr-2 text-secondary"></i>
        Add User
    </ng-container>

    <ng-container dialog-process-in-progress *ngIf="editAccountAddUserForm && editAccountAddUserForm.form">
        <div class="container-fluid py-2">
            <div class="row">
                <div class="col-12">
                    <app-select
                        [control]="editAccountAddUserForm.control"
                    ></app-select>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <p>Access</p>
                    <mat-radio-group color="primary" class="trading-account-statuses">
                        <mat-radio-button value="1">Read</mat-radio-button>
                        <mat-radio-button value="2">Write</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </ng-container>
</app-dialog>

